import UIHelper from '../ui-helper';

/**
 * Responsible for converting live maths report data from redux store into format
 * needed for export endpoints
 */
export default class LiveMathsDataConverter {
    static convertAllClasses(
        data,
        selectedDate,
        liveMathsLevel,
        reportTitle,
        isAllYears
    ) {
        const classes = data
            .find((d) => +d.level === liveMathsLevel)
            .classes.map((c) => ({ name: c.name, ...this.addScores(c) }), this);

        return {
            dateRange: UIHelper.formatDateRange(selectedDate),
            reportLevelHeader: reportTitle,
            liveMathsTableHeader: isAllYears ? 'All years' : 'All classes',
            classroomsLiveMathsData: {
                liveMathsLevelResult: {
                    [liveMathsLevel]: classes
                }
            }
        };
    }

    static convertSingleClass(data, selectedDate, liveMathsLevel, groupId) {
        const { classroomName, groupLiveMathsLevelResult } = data;
        let selectedLevelResult = groupLiveMathsLevelResult.find(
            (d) => +d.level === liveMathsLevel
        ).groups;

        if (groupId) {
            selectedLevelResult = selectedLevelResult.filter(
                (g) => g.id === groupId
            );
        }

        const groups = selectedLevelResult.map(
            (g) => ({
                id: g.id,
                name: g.name,
                courseName: g.courseName,
                studentLiveMathsResults: g.studentLiveMathsResults.map(
                    (s) => ({
                        id: s.id,
                        firstName: s.studentName.split(',')[1],
                        lastName: s.studentName.split(',')[0],
                        ...this.addScores(s)
                    }),
                    this
                )
            }),
            this
        );

        return {
            dateRange: UIHelper.formatDateRange(selectedDate),
            classroomLiveMathsData: {
                classroomName,
                groupLiveMathsLevelResult: {
                    [liveMathsLevel]: groups
                }
            }
        };
    }

    static addScores(data) {
        return {
            totalCorrect: this.mapScore(data.totalCorrect),
            topScore: this.mapScore(data.topScore),
            accuracy: this.mapScore(data.accuracy),
            questionsPerMinute: this.mapScore(data.questionsPerMinute)
        };
    }

    static mapScore(score) {
        if (score === '-') {
            return -1;
        }
        return parseInt(score, 10);
    }
}



// WEBPACK FOOTER //
// ./helpers/export-data-converter/live-maths-data-converter.js